import PropTypes from 'prop-types';

// Define Element if it's not defined. This can happen when rendering
// React server-side. See https://stackoverflow.com/a/51127130
const DomElement = typeof Element === 'undefined' ? () => {} : Element;

export default PropTypes.instanceOf(DomElement);
